import {
  DebugRestProxyKey,
  DebugRestProxyRequest,
  debugRestProxy,
} from '@frontend/api';
import Session, { OPAQUE_TOKEN } from './Session';

type DebugRestProxyCall<TPayload> = Omit<
  DebugRestProxyRequest<TPayload>,
  'opaqueToken'
>;

export const callDebugRestProxy = <
  TResponse = any,
  TPayload = Record<string, any>,
>(
  request: DebugRestProxyCall<TPayload>,
) => {
  const opaqueToken = Session.get(OPAQUE_TOKEN);
  if (!opaqueToken) {
    throw new Error('Debug session is unavailable.');
  }

  return debugRestProxy<TResponse, TPayload>({
    ...request,
    opaqueToken,
  });
};

export const getDebugProxyData = <TResponse = any>(key: DebugRestProxyKey) =>
  callDebugRestProxy<TResponse>({ key });
